import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useFetch } from 'hooks/useFetch'
import { ProxyTo } from '../../../../../pages/api/proxy/[...slug]'
import { Template } from '../typings'

type Response = Template

type Props = {
  id: string
  options?: Partial<UseQueryOptions<Response>>
}

export function transformDates(data: Response): Response {
  const scheduling = data.promotion?.scheduling

  if (!scheduling) {
    return data
  }

  return {
    ...data,
    promotion: {
      ...data.promotion,
      scheduling: {
        ...scheduling,
        start:
          typeof scheduling.start === 'string'
            ? new Date(scheduling.start)
            : scheduling.start,
        end:
          typeof scheduling.end === 'string'
            ? new Date(scheduling.end)
            : scheduling.end,
      },
    },
  }
}

export function useTemplateQuery(props: Props) {
  const { id, options } = props
  const { fetcherWrapper } = useFetch()

  const url = new URL(`/api/proxy/templates/${id}`, window.location.origin)

  function fetcher(): Promise<Response> {
    return fetcherWrapper(url, {
      headers: {
        'x-vtex-proxy-to': ProxyTo.PROMOTIONS_STORAGE,
      },
    })
      .then((r) => r.json())
      .then(transformDates)
  }

  return useQuery({
    queryKey: ['template-by-id', id],
    queryFn: fetcher,
    ...options,
  })
}
